import { atom } from "jotai";
import { EBenefitContentTab, SelectItem } from "library/types";

export const benefitContentTabAtom = atom<EBenefitContentTab>(EBenefitContentTab.enrolled);

export const selectedPackageUserAtom = atom<SelectItem | null>(null);
export const showExpiredPackagesAtom = atom<boolean>(false);
